import * as React from 'react';
import { UIText1, IconFunctionalSuccessCircle16 } from '@cian/ui-kit';

import { IListWithIconsProps, IListWithIconsItemProps } from './types';
import { ResizableWrap } from '../ResizableWrap';

import * as styles from './styles.css';

const ListWithIconsWrapper: React.FC<React.PropsWithChildren<IListWithIconsProps>> = ({ children, gap = 8 }) => {
  return (
    <ul className={styles['list']} style={{ gap }}>
      {children}
    </ul>
  );
};

const ListWithIconsItem: React.FC<React.PropsWithChildren<IListWithIconsItemProps>> = ({
  children,
  textColor = 'black_100',
  icon = (
    <ResizableWrap height={24}>
      <IconFunctionalSuccessCircle16 alignmentBaseline="baseline" />
    </ResizableWrap>
  ),
}) => {
  return (
    <li className={styles['item']}>
      <span className={styles['icon']} aria-hidden>
        {icon}
      </span>
      <UIText1 color={textColor}>{children}</UIText1>
    </li>
  );
};

export const ListWithIcons = {
  /** Список с иконкой напротив каждого пункта **/
  List: ListWithIconsWrapper,
  /** Элемент списка с иконкой (по-умолчанию IconSuccess16) **/
  Item: ListWithIconsItem,
};
